import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  SalesInvoice, SalesInvoiceCreateDTO, SalesInvoiceEditDTO, VoidDTO, SalesInvoicePage,
} from '../interfaces/sales/salesInvoice.interface';

export const SalesInvoiceService = {
  listByInstitution: async (institutionId: string, page = 0, size = 10): Promise<SalesInvoicePage> =>
    (await axios.get(`${ENDPOINTS.SALES_INVOICE.LIST_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}`)).data,
  // Backend returns a paginated Page<SalesInvoiceDTO>; unwrap to the array the
  // callers expect. Request a large page so the customer-level outstanding total
  // reflects every open invoice rather than just the first default page.
  listByCustomer: async (customerId: string): Promise<SalesInvoice[]> =>
    (await axios.get(`${ENDPOINTS.SALES_INVOICE.LIST_BY_CUSTOMER(customerId)}?page=0&size=1000`)).data.content,
  getById: async (id: string): Promise<SalesInvoice> =>
    (await axios.get(ENDPOINTS.SALES_INVOICE.GET_BY_ID(id))).data,
  create: async (dto: SalesInvoiceCreateDTO): Promise<SalesInvoice> =>
    (await axios.post(ENDPOINTS.SALES_INVOICE.CREATE, dto)).data,
  // DRAFT-only full replacement (PUT /sales-invoice/{id}).
  update: async (id: string, dto: SalesInvoiceCreateDTO): Promise<SalesInvoice> =>
    (await axios.put(ENDPOINTS.SALES_INVOICE.UPDATE(id), dto)).data,
  remove: async (id: string): Promise<void> =>
    (await axios.delete(ENDPOINTS.SALES_INVOICE.DELETE(id))).data,
  issue: async (id: string): Promise<SalesInvoice> =>
    (await axios.post(ENDPOINTS.SALES_INVOICE.ISSUE(id))).data,
  voidInvoice: async (id: string, dto: VoidDTO): Promise<SalesInvoice> =>
    (await axios.post(ENDPOINTS.SALES_INVOICE.VOID(id), dto)).data,
  // Audit-trailed correction for ISSUED/PARTIALLY_PAID invoices; requires editReason (PUT /sales-invoice/{id}/edit).
  edit: async (id: string, dto: SalesInvoiceEditDTO): Promise<SalesInvoice> =>
    (await axios.put(ENDPOINTS.SALES_INVOICE.EDIT(id), dto)).data,
  downloadPdf: async (id: string): Promise<Blob> =>
    (await axios.get(ENDPOINTS.SALES_INVOICE.PDF(id), { responseType: 'blob' })).data,
  email: async (id: string): Promise<void> =>
    (await axios.post(ENDPOINTS.SALES_INVOICE.EMAIL(id))).data,
};
